import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CTAButton from '../../../ui/ctaButton';
import Seo from '../../../components/Seo';
import { colors, fontFamilies } from '../../../constants/theme';

/**
 * Rendered for any unmatched route.
 *
 * The SPA cannot set the HTTP status itself — Nginx serves the prerendered
 * 404.html with a real 404 for unknown paths. This page is the visible half of
 * that pair, and it carries noindex so a soft 404 never enters the index.
 */
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Seo title="Page Not Found" description="This page could not be found." noindex />
      <Box
        component="main"
        sx={{
          minHeight: { xs: '60vh', md: '70vh' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 3,
            }}
          >
            <Typography
              component="p"
              sx={{
                fontFamily: fontFamilies.gotham,
                fontSize: { xs: 56, md: 84 },
                lineHeight: 1,
                color: colors.lightBorder,
              }}
            >
              404
            </Typography>

            <Typography
              component="h1"
              sx={{
                fontFamily: fontFamilies.gotham,
                fontWeight: 400,
                color: colors.primary,
                fontSize: { xs: 26, sm: 32, md: 40 },
              }}
            >
              This page could not be found
            </Typography>

            <Typography
              sx={{
                fontFamily: fontFamilies.quicksand,
                color: colors.textLight,
                fontSize: { xs: 15, md: 18 },
              }}
            >
              The link may be out of date, or the page may have moved. You can head back to the
              homepage or get in touch and we will point you in the right direction.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: 2,
                mt: 1,
              }}
            >
              <CTAButton text="Back to Homepage" onClick={() => navigate('/')} />
              <CTAButton variant="outlined" text="Contact Us" onClick={() => navigate('/contact')} />
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NotFound;
